"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthenticationProvider = exports.getMessageFromError = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importStar(require("react"));

var AuthenticationContext_1 = require("./AuthenticationContext");

var constants_1 = require("./lib/constants");

var authenticationActions_1 = require("./state/authenticationActions");

var authenticationReducer_1 = require("./state/authenticationReducer");

var authenticationState_1 = require("./state/authenticationState");

var getMessageFromError = function getMessageFromError(error) {
  if (typeof error === 'string') {
    return error;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return null;
};

exports.getMessageFromError = getMessageFromError;

var AuthenticationProvider = function AuthenticationProvider(_a) {
  var tokenProvider = _a.tokenProvider,
      children = _a.children,
      loginUrl = _a.loginUrl;
  var Provider = AuthenticationContext_1.AuthenticationContext.Provider;

  var _b = (0, react_1.useReducer)(authenticationReducer_1.authenticationReducer, authenticationState_1.initialState),
      state = _b[0],
      dispatch = _b[1];

  var setAuthenticationToken = function setAuthenticationToken(token) {
    return dispatch({
      type: authenticationActions_1.AUTHENTICATION_ACTIONS.AUTHENTICATION_TOKEN_SET,
      payload: {
        token: token
      }
    });
  };

  var predicate = {
    isInitial: state.authenticationStatus === constants_1.FETCH_STATUSES.INITIAL,
    isLoading: state.authenticationStatus === constants_1.FETCH_STATUSES.LOADING,
    isLoaded: state.authenticationStatus === constants_1.FETCH_STATUSES.SUCCESS,
    hasError: state.authenticationStatus === constants_1.FETCH_STATUSES.ERROR
  };
  (0, react_1.useEffect)(function () {
    var setAuth = function setAuth() {
      return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var token, error_1;
        return tslib_1.__generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              dispatch({
                type: authenticationActions_1.AUTHENTICATION_ACTIONS.AUTHENTICATION_TOKEN_LOAD
              });
              _a.label = 1;

            case 1:
              _a.trys.push([1, 3,, 4]);

              if (!tokenProvider) throw new Error('auth provider does not exist');
              return [4
              /*yield*/
              , tokenProvider()];

            case 2:
              token = _a.sent().token;
              if (!token || token.length === 0) throw new Error('no token found');
              setAuthenticationToken(token);
              return [3
              /*break*/
              , 4];

            case 3:
              error_1 = _a.sent();

              if (error_1 instanceof Error) {
                dispatch({
                  type: authenticationActions_1.AUTHENTICATION_ACTIONS.AUTHENTICATION_TOKEN_ERROR,
                  payload: (0, exports.getMessageFromError)(error_1)
                });
              }

              return [3
              /*break*/
              , 4];

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    if (loginUrl) {
      dispatch({
        type: authenticationActions_1.AUTHENTICATION_ACTIONS.LOGIN_URL_SET,
        payload: {
          loginUrl: loginUrl
        }
      });
    }

    if (typeof tokenProvider === 'function') {
      setAuth();
    }
  }, [tokenProvider, loginUrl]);
  return react_1.default.createElement(Provider, {
    value: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, state), predicate), {
      setAuthenticationToken: setAuthenticationToken
    })
  }, children);
};

exports.AuthenticationProvider = AuthenticationProvider;
exports.AuthenticationProvider.displayName = 'AuthenticationProvider';